import { addMessages, init } from 'svelte-i18n';
import en from './i18n/en.json';

addMessages('en', en);
// TODO: Fix i18n integration
// eslint-disable-next-line @typescript-eslint/no-floating-promises
init({ fallbackLocale: 'en', initialLocale: 'en' });

export * from './common/format.js';

export * as MONITORING from './common/monitoring.js';
export * as ANALYTICS from './common/analytics.js';

// Stores
export * from './stores/messages.js';

export { TOKEN, CAMPAIGN_TOKEN, STATE, IS_AUTHENTICATED } from './stores/state.js';
export { QUERY_STATE } from './stores/query.js';

// Components
export * from './components/index.js';

// Elements
export * from './elements/index.js';

// Typography
export * from './typography/index.js';

// Modal
export { openModal, closeModal } from './common/modal.js';

// Undo
export { addUndo } from './stores/undo.js';

// TODO: These components should not be exposed directly

// Odds & Ends
export { default as Tag } from './selects/tag/Tag.svelte';
export { default as InputToggle } from './selects/input-toggle/InputToggle.svelte';
export { default as Icon } from './elements/icon/Icon.svelte';
export { default as Badge } from './elements/badge/Badge.svelte';
export { default as InputSearch } from './inputs/input-search/InputSearch.svelte';
export { default as InputPercentage } from './inputs/input-percentage/InputPercentage.svelte';
export { default as InputMonetary } from './inputs/input-monetary/InputMonetary.svelte';
export { default as Textarea } from './inputs/textarea/Textarea.svelte';
export { default as Count } from './elements/count/Count.svelte';
export { default as SelectSingle } from './selects/select-single/SelectSingle.svelte';
export { default as AutocompleteSingle } from './selects/autocomplete-single/AutocompleteSingle.svelte';
export { default as InputRadioList } from './selects/input-radio-list/InputRadioList.svelte';

/* Scopes ------------------------------------------------------ */

// Authentication
export * from './scopes/authentication/index.js';

// Organization
export * from './scopes/organization/index.js';

// Domain
export * from './scopes/domain/index.js';

// Channels
export * from './scopes/channel/index.js';

// User
export * from './scopes/user/index.js';

// Auction
export * from './scopes/auction/index.js';

// Shipping
export * from './scopes/shipping/index.js';

// Payment
export * from './scopes/payment/index.js';

// Finance
export * from './scopes/finance/index.js';

// Verticals
export * from './scopes/vertical/index.js';

// Address
export * from './scopes/address/index.js';

// Bid
export * from './scopes/bid/index.js';

// Product
export * from './scopes/product/index.js';

// Variant
export * from './scopes/variant/index.js';

// Subscription
export * from './scopes/subscription/index.js';

// Markets
export * from './scopes/market/index.js';

// Brands
export * from './scopes/brand/index.js';

// Categories
export * from './scopes/category/index.js';

// Locale
export * from './scopes/locale/index.js';

// Campaign
export * from './scopes/campaign/index.js';

// Config
export * from './scopes/config/index.js';

// Contact
export * from './scopes/contact/index.js';